import { ModuleFE_Variable } from '@app/hcs-frontend';
import { currentTimeMillis, Hour } from '@nu-art/ts-common';
const loremIpsum644 = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sed risus varius, rhoncus ex non, auctor nunc. Quisque ornare arcu lacus, et eleifend quam fringilla nec. Nulla vulputate justo at purus viverra sodales. Donec nec odio id nisi vehicula lacinia. Suspendisse ac velit non dolor tempus dictum sit amet et sem. Vestibulum aliquam metus ut nisi facilisis eleifend. Pellentesque varius metus nec consequat tincidunt. Quisque a metus lorem. In hac habitasse platea dictumst. Mauris non turpis sit amet ante rhoncus iaculis. Nullam ac massa id odio tempor molestie vitae at tellus. Morbi et quam rutrum, blandit dolor et, venenatis mauris.';
const ccVarId = 'f1fd8f1c82a3634ba6500c3ce70dd7ac';
const generateTextualFindingTest = (results) => {
    const variable = ModuleFE_Variable.cache.unique(ccVarId);
    const result = {
        variable,
        metadata: {
            source: 'advisor'
        },
        results: results.map((resultProps, index) => {
            return {
                rawValue: loremIpsum644.substring(0, Math.floor((Math.random() * 644))),
                currentEncounter: resultProps.currentEncounter,
                timestamp: currentTimeMillis() - (index * Hour),
            };
        })
    };
    return result;
};
export const FindingTooltipTextualTests = () => [
    {
        label: 'Single Value',
        data: generateTextualFindingTest([{ currentEncounter: true }])
    },
    {
        label: 'Single Value - Previous Encounter',
        data: generateTextualFindingTest([{ currentEncounter: false }])
    },
    {
        label: 'Multi Value',
        data: generateTextualFindingTest([
            { currentEncounter: true },
            { currentEncounter: true },
            { currentEncounter: true },
        ])
    },
    {
        label: 'Multi Value W/ Previous Encounter',
        data: generateTextualFindingTest([
            { currentEncounter: true },
            { currentEncounter: false },
            { currentEncounter: false },
        ])
    },
];
//# sourceMappingURL=textual.js.map